import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-modal',
  templateUrl: './site-modal.component.html',
  styleUrls: ['./site-modal.component.scss']
})
export class SiteModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
